import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["step"];
  static values = {
    current: { type: Number, default: 1 },
    minInterests: { type: Number, default: 3 },
    minPhotos: { type: Number, default: 2 }
  };

  connect() {
    this.showCurrentStep();
  }

  nextStep(step) {
    if (this.validateCurrentStep()) {
      this.currentValue = step;
      this.showCurrentStep();
    }
  }

  showCurrentStep() {
    this.stepTargets.forEach((el, index) => {
      el.classList.toggle("active", index + 1 === this.currentValue);
    });
  }

  validateCurrentStep() {
    let isValid = false;

    switch (this.currentValue) {
      case 1:
        isValid = this.validateStep1();
        break;
      case 2:
        isValid = this.validateStep2();
        break;
      case 3:
        isValid = this.validateStep3();
        break;
      case 4:
        isValid = this.validateStep4();
        break;
    }

    this.updateButtonStates(isValid);
    return isValid;
  }

  validateStep1() {
    // Delegate to form_validation_controller
    const formValid = document.querySelector(".step1").dataset.formValid === "true";
    return formValid;
  }

  validateStep2() {
    const selectedGender = this.data.get("selectedGender");
    const selectedLookingFor = this.data.get("selectedLookingFor");
    const age = parseInt(this.data.get("age") || "0");

    return selectedGender && selectedLookingFor && age >= 18;
  }

  validateStep3() {
    const selectedInterestsCount = parseInt(this.data.get("selectedInterestsCount") || "0");
    return selectedInterestsCount >= this.minInterestsValue;
  }

  validateStep4() {
    const uploadedPhotosCount = parseInt(this.data.get("uploadedPhotosCount") || "0");
    return uploadedPhotosCount >= this.minPhotosValue;
  }

  updateButtonStates(isValid) {
    const continueBtn = this.element.querySelector('.continue-btn');
    const completeBtn = this.element.querySelector('.complete-btn');

    if (continueBtn) continueBtn.disabled = !isValid;
    if (completeBtn) completeBtn.disabled = !isValid;
  }
}
